import Modal from 'app/components/layouts/Modals/Index';
import React, { useEffect } from 'react';
import { useRouter } from 'next/router';

const ModalZoomImage = ({ image, setImage }) => {
  const router = useRouter()

  useEffect(() => {
    setTimeout(() => {
      const container = document.querySelector('#blog .box-news-area');
      if (!container) return;

      const handleClick = (e) => {
        if (e.target.tagName === 'IMG') {
          setImage(e.target);
        }
      };

      container.addEventListener('click', handleClick);
      return () => container.removeEventListener('click', handleClick);
    }, 1000);
  }, [router.asPath]);

  return (
    <div>
      <Modal
        imageUrl={image?.src || ''}
        imageAlt={'Zoomed image'}
        show={!!image}
        onClose={() => setImage(undefined)}
        showConfirmButton={false}
        customClass={{
          image: 'max-w-full max-h-screen',
          popup: 'p-0',
        }}
        width='auto'
      >
      </Modal >
      <style jsx global>{`
        #blog .box-news-area img:hover {
          opacity: 0.8;
          cursor: pointer;
        }
        .swal2-popup .swal2-image {
          margin: 0 auto;
        }
      `}</style>
    </div>
  )
}

export default ModalZoomImage
